import "./WhyChoose.scss";

const WHY_CHOOSE_DATA = [
  {
    number: "01",
    title: "Advisors When Decisions Matter Most",
    description:
      "We partner with promoters, boards, and leadership teams at pivotal moments, where clarity of judgment and depth of experience directly shape long-term outcomes.",
    type: "white-card",
    icon: "/icons/home/why-choose/why-choose-advisors.webp",
  },
  {
    number: "02",
    title: "Insight That Converts into Impact",
    description:
      "Our work is designed to deliver tangible results, not just strategic direction. Every engagement is anchored in improving profitability, strengthening performance, and embedding execution discipline across the organization.",
    type: "peach-card",
    icon: "/icons/home/why-choose/why-choose-insights.webp",
  },
  {
    number: "03",
    title: "Leadership-Led, Experience-Driven",
    description:
      "Amicus is led by Sanjeev Jain, ex-CFO of Gati Limited and FedEx, bringing decades of operating, financial, and governance experience. Our advice is grounded in real-world leadership, not theoretical models.",
    type: "white-card",
    icon: "/icons/home/why-choose/why-choose-leadership.webp",
  },
  {
    number: "04",
    title: "End-to-End Value Across the Business Lifecycle",
    description:
      "From diagnostics and transformation to CFO services, IPO readiness, fund raising, and transactions, we offer integrated advisory across growth, capital, and institutional maturity, ensuring alignment between strategy and execution.",
    type: "peach-card",
    icon: "/icons/home/why-choose/why-choose-end.webp",
  },
  {
    number: "05",
    title: "A True Extension of Management",
    description:
      "We work shoulder-to-shoulder with leadership teams through structured reviews, performance frameworks, and governance mechanisms, embedding accountability and sustaining results long after the engagement concludes.",
    type: "white-card",
    icon: "/icons/home/why-choose/why-choose-extension.webp",
  },
];

const WhyChoose = () => {
  return (
    <section className="why-choose-section">
      <div className="why-choose-grid">
        <div className="left-content">
          <span className="subtitle">Why Choose Us?</span>
          <h2 className="title">
            Clarity & Execution at Every Stage of Growth
          </h2>
        </div>
        <div className="right-content">
          {WHY_CHOOSE_DATA.map((item, index) => {
            return (
              <div key={index} className={`choose-card ${item.type}`}>
                <span className="card-number">{item.number}</span>
                <div className="card-body-wrapper">
                  <h3 className="card-title">{item.title}</h3>
                  <p className="card-text">{item.description}</p>
                </div>
                <div className="card-watermark">
                  <img src={item.icon} alt="" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
